module.exports = __webpack_public_path__ + "img/roll-1771.d2b5583d.png";